import { Col, Divider, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { TRANSLATION_NAMESPACES } from 'util/translation/constant';
import { CleaningReportList } from './components/CleaningReportList';
import { CleaningMachineUtilisation } from './components/CleaningReportUtilization';
import { CleaningTaskCompletion } from './components/CleaningTaskCompletion';

export const CleaningReport = () => {
  const { t } = useTranslation(TRANSLATION_NAMESPACES.CLEANING_REPORT);

  return (
    <div className="cleaningReports">
      <div>
        <h2 className="bold">{t('pageTitle')}</h2>
      </div>
      <Row gutter={[24, { xs: 32, sm: 32, xl: 24 }]}>
        <Col xs={24} sm={24} xl={12}>
          <CleaningMachineUtilisation />
        </Col>
        <Col xs={24} sm={24} xl={12}>
          <CleaningTaskCompletion />
        </Col>
      </Row>
      <Divider className="cleaningReports-divider" />
      <CleaningReportList />
    </div>
  );
};
